import { useParams } from 'react-router';

import { DEFAULT_LOCALE, isLocale } from './config';

/** Locale from the `:locale` route segment (falls back to the default one). */
export function useLocale(): string {
  const { locale } = useParams();
  return isLocale(locale) ? locale : DEFAULT_LOCALE;
}
